<app-navbar></app-navbar>
<section>
    <div class="container" style="padding: 100px;">
      <div class="row">
            <div class="col-md-12">
                <div class="dashboard">
                    <div class="publication">
                        <!-- Link added here -->
                        <a href="https://drive.google.com/file/d/1msWJc-esFY7SUfwaGvsAoRIBmrUr5xCI/view?usp=sharing" target="_blank" download>
                            <img src="/assets/img/school/book1.png" alt="Publication 1">
                        </a>
                        <h3>বিশেষ চাহিদাসম্পন্ন শিশুর ব্যবস্থাপনা</h3>                        <!-- <p>Description of Publication 1</p> -->
                    </div>
                    <div class="publication">
                      <img src="assets/img/school/logo.png" alt="Publication 2">
                      <h3>Publication 2</h3>
                      <p>Description of Publication 2</p>
                    </div>
                    <!-- Add more publication items here -->
                  </div>
            
            </div>
          </div>
        </div>
  </section>
